<template>
  <div id="app" :key="pageKey">
    <Navigator />
    <!-- 首屏 -->
    <FirstScreen />
    <!-- <FirstScreenVideo /> -->
    <!-- 自然舒适 -->
    <NaturalComfort />
    <!-- 新设计，光鲜亮丽 -->
    <NewDesign />
    <!-- 光栅壁纸 -->
    <GratingWallpaper />
    <!-- 个性化锁屏 -->
    <CustomisableLockScreen />
    <!-- 流畅引擎 -->
    <FluidEngine />
    <!-- 秒抢引擎 -->
    <SecondGrabEngine />
    <!-- 5年持久如新 -->
    <FiveYearsDurability />
    <!-- 性能与续航 -->
    <PerformanceAndEndurance />
    <!-- 更懂你，一用就AI上 -->
    <AIScreen />
    <!-- 韩学剑 begin-->
    <!-- 跨生态，都好用 -->
    <CrossEcology />
    <!-- 呵护你的眼眸 -->
    <EyeCare/>
    <!-- 科技照亮每一个日常 -->
    <TechnologyIlluminate />
    <!-- 自然舒适，值得信赖 -->
    <SecurityGuard />
    <!-- 往下看，更多精彩 -->
    <MoreModule />
    <!-- 适配计划 -->
    <AdaptationPlan />
    <!-- 更多精彩 | 一同目睹 -->
    <OtherLink />
    <!-- 韩学剑 end-->

    <!-- 注释 -->
    <NotesModule />
    <Toast ref="toast" />
    <!-- 功能测试 -->
    <!-- <button class="backtop" @click="backTop">back top</button> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Navigator from "./view/Navigator.vue";
import FirstScreen from "./view/FirstScreen.vue";
import FirstScreenVideo from "./view/FirstScreenVideo.vue";
import NaturalComfort from "./view/NaturalComfort.vue";
import NewDesign from "./view/NewDesign.vue";
import SecurityGuard from "./view/SecurityGuard.vue";
import MoreModule from "./view/MoreModule.vue";
import AdaptationPlan from "./view/AdaptationPlan.vue";
import OtherLink from "./view/OtherLink.vue";
import NotesModule from "./view/NotesModule.vue";
import GratingWallpaper from "./view/GratingWallpaper.vue";
import CustomisableLockScreen from "./view/CustomisableLockScreen.vue";
import FluidEngine from "./view/FluidEngine.vue";
import SecondGrabEngine from "./view/SecondGrabEngine.vue";
import FiveYearsDurability from "./view/FiveYearsDurability.vue";
import AIScreen from "./view/AIScreen.vue";
import CrossEcology from "./view/CrossEcology.vue";
import EyeCare from "./view/EyeCare.vue";
import TechnologyIlluminate from "./view/TechnologyIlluminate.vue";
import PerformanceAndEndurance from "./view/PerformanceAndEndurance.vue";
import Lenis from '@studio-freight/lenis'
import { gsap, ScrollTrigger } from '@/utils/gsapConfig'

let sidebarTop,
  sidebarHeight,
  naturalComfortTop,
  newDesignTop,
  ndSwiperTop,
  gratingWallpaperTop,
  carouselTop,
  fluidTop,
  fluidSwiperTop,
  fluidTextTop,
  consumptionTop,
  aiTop,
  crossEcologyTop,
  eyeCareTop,
  technologyTop,
  securityGuardTop,
  moreTop,
  morePlanTop,
  otherLinkTop,
  notesModuleTop;
export default {
  name: "App",
  components: {
    Navigator,
    FirstScreen,
    FirstScreenVideo,
    NaturalComfort,
    NewDesign,
    GratingWallpaper,
    CustomisableLockScreen,
    FluidEngine,
    SecondGrabEngine,
    FiveYearsDurability,
    SecurityGuard,
    MoreModule,
    AdaptationPlan,
    OtherLink,
    NotesModule,
    AIScreen,
    CrossEcology,
    EyeCare,
    TechnologyIlluminate,
    PerformanceAndEndurance,
  },
  data() {
    return {
      pageKey: 1,
      lenis: null,
    };
  },
  computed: {
    ...mapState({
      deviceType: state => state.deviceType,
    }),
  },
  watch:{
    deviceType(){
      this.pageKey++
    },
  },
  created() {
    if (history.scrollRestoration) {
      console.warn("history.scrollRestoration = manual");
      history.scrollRestoration = "manual";
    }
    this.getDeviceSize();
  },
  mounted() {
    // alert(`${window.screen.width}, ${window.screen.height}`)
    this.init();
    this.addDarkThemeMeta()
    if(sessionStorage.getItem('pageScrollTop')){
      window.scrollTo(0,sessionStorage.getItem('pageScrollTop'))
    }
  },
  methods: {
    ...mapMutations({
      updateDeviceType: 'UPDATE_DEVICE_TYPE',
    }),
    addDarkThemeMeta() {
      let colorSchemeMeta = document.createElement('meta');
      colorSchemeMeta.name = 'color-scheme';
      colorSchemeMeta.content = 'light dark';
      document.head.appendChild(colorSchemeMeta);
    },
    initLenis() {
      this.lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
        smoothTouch: false,
        touchMultiplier: 1,
      });

      // 保存原始的 scrollTo 方法
      const originalScrollTo = window.scrollTo;

      // 重写 scrollTo 方法
      window.scrollTo = (...args) => {
        if (this.lenis) {
          this.lenis.stop();
          originalScrollTo.apply(window, args);
          this.lenis.start();
        } else {
          originalScrollTo.apply(window, args);
        }
      };

      // 设置 RAF
      const raf = (time) => {
        this.lenis.raf(time);
        requestAnimationFrame(raf);
      };
      requestAnimationFrame(raf);

      // 更新 ScrollTrigger
      this.lenis.on('scroll', ScrollTrigger.update);

      gsap.ticker.lagSmoothing(100,16);
    },
    backTop() {
      window.scrollTo(0,0)
    },
    showToast(text) {
      this.$refs.toast.show(text);
    },
    getDeviceSize() {
      // const windowWidth = window.innerWidth;
      const windowWidth = window.screen.width
      document.body.classList.remove("isMobile", "isPad", "isPC");
      // 判断是否为移动设备（设计稿360）
      if (windowWidth < 676) {
        this.updateDeviceType('isMobile');
        document.body.classList.add("isMobile");
      }
      else if (windowWidth >= 676 && windowWidth <= 1120) {
        this.updateDeviceType('isPad');
        document.body.classList.add("isPad");
      }
      // 判断是否为桌面设备（设计稿1920）
      else {
        this.updateDeviceType('isPC');
        document.body.classList.add("isPC");
      }
    },
    // 暂未使用
    checkImgSupported() {
      if (this.isWebPSupported()) {
        document.body.classList.add("webpSupport");
      }
      if (this.isAVIFSupported()) {
        document.body.classList.add("avifSupport");
      }
    },
    isWebPSupported() {
      const elem = document.createElement("canvas");
      if (!!(elem.getContext && elem.getContext("2d"))) {
        return elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
      }
      return false;
    },
    isAVIFSupported() {
      return "transferControlToOffscreen" in HTMLCanvasElement.prototype;
    },
    init() {
      this.getAllModulesOffsetTop();
      this.pageResize();
      if (window.screen.width > 1120) {
        this.initLenis()
        this.sidebarInit();
        this.pageScroll();
        this.sidebarClick();
      }
      window.vpHeaderChangeDeeplinkUrl &&
        window.vpHeaderChangeDeeplinkUrl(
          "space://vivo.com/web?uri=https://www.vivo.com.cn/originos"
        );
    },
    // 初始化拿到各模块top值，不再实时获取，实时获取有bug
    getAllModulesOffsetTop() {
      sidebarTop = $(".umx-sidebar")[0].getBoundingClientRect().top;
      sidebarHeight = $(".umx-sidebar").height();
      // 自然舒适
      naturalComfortTop = $(".natural-comfort").offset().top;
      // 新设计 0
      newDesignTop = $(".new-design").offset().top;
      // 新设计 - swiper
      ndSwiperTop = $(".nd-swiper").offset().top;
      // 光栅壁纸
      gratingWallpaperTop = $(".grating-wallpaper").offset().top;
      // 轮播转盘
      carouselTop = $(".carousel-container").offset().top;
      // 更流畅 1
      fluidTop = $(".fluid-engine").offset().top;
      // 更流畅 - swiper
      fluidSwiperTop = $(".fluid-engine-container").offset().top;
      // 更流畅 - 文字
      fluidTextTop = $(".fluid-engine-gradient-text-container").offset().top;
      // 更低耗 2
      consumptionTop = $(".performance-and-endurance").offset().top;
      // 更有AI 3
      aiTop = $(".ai-screen-wrap").offset().top;
      // 跨生态 4
      crossEcologyTop = $(".cross-ecology").offset().top;
      // 更护眼 5
      eyeCareTop = $(".eye-care-screen").offset().top;
      // 无障碍 6
      technologyTop = $(".technology-screen").offset().top;
      // 更安全 7
      securityGuardTop = $(".security-guard").offset().top;
      // 更多精彩 8
      moreTop = $(".more-module").offset().top;
      // 适配计划 9
      morePlanTop = $(".adaptation-plan").offset().top;
      // 更多精彩｜一同目睹
      otherLinkTop = $(".other-link").offset().top;
      // 注释
      notesModuleTop = $(".notes-module").offset().top;
    },
    sidebarInit() {
      const windowScrollTop = $(window).scrollTop();
      // 本地需要 TODO:上线注释
      // if (windowScrollTop > 40) {
      //   $("body").addClass("vp-head-fixed-flag");
      // } else {
      //   $("body").removeClass("vp-head-fixed-flag");
      // }
      if (
        // windowScrollTop < 2000 ||
        windowScrollTop > notesModuleTop - sidebarTop
      ) {
        $(".umx-sidebar").addClass("none");
      } else {
        $(".umx-sidebar").removeClass("none");
      }
      if (windowScrollTop > morePlanTop - sidebarTop) {
        // 适配计划
        $(".umx-sidebar").addClass("black");
        $(".umx-sidebar").attr("sidebar", 9);
        $(".sidebar-item").removeClass("active").eq(9).addClass("active");
      } else if (windowScrollTop > moreTop - sidebarTop) {
        // 更多精彩
        $(".umx-sidebar").addClass("black");
        $(".umx-sidebar").attr("sidebar", 8);
        $(".sidebar-item").removeClass("active").eq(8).addClass("active");
        $(".umx-sidebar").css("mixBlendMode", "");
      } else if (windowScrollTop > securityGuardTop - sidebarTop) {
        // 更安全
        $(".umx-sidebar").removeClass("black");
        $(".umx-sidebar").attr("sidebar", 7);
        $(".sidebar-item").removeClass("active").eq(7).addClass("active");
        $(".umx-sidebar").css("mixBlendMode", "");
      } else if (windowScrollTop > technologyTop - sidebarTop) {
        $(".umx-sidebar").css("mixBlendMode", "");
        // 无障碍
        $(".umx-sidebar").addClass("black");
        $(".umx-sidebar").attr("sidebar", 6);
        $(".sidebar-item").removeClass("active").eq(6).addClass("active");
      } else if (windowScrollTop > eyeCareTop - sidebarTop) {
        // 更护眼
        $(".umx-sidebar").removeClass("black");
        $(".umx-sidebar").attr("sidebar", 5);
        $(".sidebar-item").removeClass("active").eq(5).addClass("active");
        $(".umx-sidebar").css("mixBlendMode", "");
      } else if (windowScrollTop > crossEcologyTop - sidebarTop) {
        // 跨生态
        $(".umx-sidebar").addClass("black");
        $(".umx-sidebar").attr("sidebar", 4);
        $(".sidebar-item").removeClass("active").eq(4).addClass("active");
      } else if (windowScrollTop > aiTop - sidebarTop) {
        // 更有AI
        $(".umx-sidebar").addClass("black");
        $(".umx-sidebar").attr("sidebar", 3);
        $(".sidebar-item").removeClass("active").eq(3).addClass("active");
      } else if (windowScrollTop > consumptionTop - sidebarTop) {
        // 更低耗
        $(".umx-sidebar").removeClass("black");
        $(".umx-sidebar").attr("sidebar", 2);
        $(".sidebar-item").removeClass("active").eq(2).addClass("active");
      } else if (windowScrollTop > fluidTop - sidebarTop) {
        // 更流畅

        $(".umx-sidebar").removeClass("black");
        $(".umx-sidebar").attr("sidebar", 1);
        $(".sidebar-item").removeClass("active").eq(1).addClass("active");
        
        if (windowScrollTop > fluidSwiperTop - sidebarTop && windowScrollTop <= fluidTextTop - sidebarTop) {
          $(".umx-sidebar").addClass("none");
        } else {
          $(".umx-sidebar").removeClass("none");
        }
      } else if (windowScrollTop > newDesignTop - sidebarTop) {
        // 新设计
        $(".umx-sidebar").addClass("black");
        $(".umx-sidebar").css("mixBlendMode", "");
        $(".umx-sidebar").attr("sidebar", 0);
        $(".sidebar-item").removeClass("active").eq(0).addClass("active");
        if (windowScrollTop > ndSwiperTop - sidebarHeight && windowScrollTop <= gratingWallpaperTop - sidebarTop) {
          // 在ndSwiperTop和gratingWallpaperTop之间隐藏
          $(".umx-sidebar").addClass("none");
        } else if (windowScrollTop > carouselTop - sidebarTop - sidebarHeight) {
          // 在carouselTop之后隐藏
          $(".umx-sidebar").addClass("none");
        } else {
          // 其他情况显示：ndSwiperTop之前，gratingWallpaperTop到carouselTop之间
          $(".umx-sidebar").removeClass("none");
        }
      } else {
        $(".umx-sidebar").addClass("none");
      }

    },
    pageScroll() {
      const that = this;
      $(window).on("scroll", function () {
        sessionStorage.setItem('pageScrollTop', $(window).scrollTop())
        that.getAllModulesOffsetTop();
        that.sidebarInit();
      });
    },
    pageResize() {
      const that = this;
      $(window).on("resize", function () {
        that.getDeviceSize();
        that.getAllModulesOffsetTop();
        if (window.innerWidth > 1120) {
          that.sidebarInit();
        }
      });
    },
    sidebarClick() {
      const that = this;
      $(".sidebar-item").on("click", function () {
        const index = $(this).index();
        $(".umx-sidebar").attr("sidebar", index);
        $(".sidebar-item").removeClass("active").eq(index).addClass("active");
        const offsetTop = $('[data-sidebar="' + index + '"]').offset().top;
        that.$nextTick(() => {
          window.scrollTo(0, offsetTop);
        });
      });
    },
  },
};
</script>

<style lang="scss">
.backtop {
  position: fixed;
  bottom: 100px;
  right: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 0;
  background: rgba(255, 0, 0, 0.5);
  font-size: 12px;
  color: #fff;
  z-index: 99;
  cursor: pointer;
}
* {
  box-sizing: border-box;
}
picture {
  display: inline-block;
  font-size: 0;
}
#app {
  font-family: "vivoSansSCVF400"; //"vivoSansSC600", "VIVO-FONT-WEB-BOLD","VIVO-FONT-NAV-BOLD", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow: hidden;
  background: #fff;
  min-height: 100vh;
  line-height: 1.2;
  .full-screen {
    height: calc(100vh - 86px); // 固定header
    // height: 100vh;
    width: calc(100vw - 17px); // 滚动条
    display: flow-root;
  }
  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .textalignL {
    text-align: left;
  }
  .textalignR {
    text-align: right;
  }
  .ovhide {
    overflow: hidden;
  }
}
@media screen and (max-width: 1199px) {
  #app {
    .full-screen {
      width: 100vw;
    }
  }
}

@media (prefers-color-scheme: dark) {
  #app {
    background: #000;
  }
}
</style>
